// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__ffqXr"};